import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import getLocal from '@/app/utils/i18n';

let maskScene: any = null;
export default function R() {
    const { useLang, useEffect, useState, gtm } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [active, setActive] = useState(0);
    const [textEnter, setTextEnter] = useState(false);

    let cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/18_1',
            tab: t('secR_card1_tab'),
            number: t('secR_card1_number'),
            capacity: t('secR_card1_capacity'),
            voltage: t('secR_card1_voltage'),
            input: t('secR_card1_input'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/18_2',
            tab: t('secR_card2_tab'),
            number: t('secR_card2_number'),
            capacity: t('secR_card2_capacity'),
            voltage: t('secR_card2_voltage'),
            input: t('secR_card2_input'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/18_3',
            tab: t('secR_card3_tab'),
            number: t('secR_card3_number'),
            capacity: t('secR_card3_capacity'),
            voltage: t('secR_card3_voltage'),
            input: t('secR_card3_input'),
        },
    ];

    if (locale === 'au') {
        cards = [
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1753259828942/R1.jpg',
                tab: t('secR_card1_tab'),
                number: t('secR_card1_number'),
                capacity: t('secR_card1_capacity'),
                voltage: t('secR_card1_voltage'),
                input: t('secR_card1_input'),
            },
            {
                img: 'https://websiteoss.ecoflow.com/upload/image/1753259829021/R2.jpg',
                tab: t('secR_card2_tab'),
                number: t('secR_card2_number'),
                capacity: t('secR_card2_capacity'),
                voltage: t('secR_card2_voltage'),
                input: t('secR_card2_input'),
            },
        ];
    }

    const handleClickTab = (k: number) => {
        setActive(k);
        console.log(cards[k].tab);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: cards[k].tab,
        });
        if (window?.innerWidth < 768) {
            const target = document.querySelector('.dpu-detail-R .tabs') as HTMLElement;
            if (target) {
                const { scrollLeft, scrollWidth } = target;
                if (k === 0) {
                    return (target.scrollLeft = 0);
                }
                if (k === 1) {
                    return (target.scrollLeft = (scrollWidth - scrollLeft) / 2);
                }
                if (k === 2) {
                    return (target.scrollLeft = scrollWidth - scrollLeft);
                }
            }
        }
    };

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.3;
            const startH = Math.min(clientH, 250);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-R',
                triggerHook: 1,
                offset: startH,
                duration: 200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    return (
        <section className={`dpu-detail-R dpu-detail-section${textEnter ? ' textEnter' : ''} ${css['dpu-detail-R']}`}>
            <EfSpec />
            <h2 className="title">{t('secR_title')}</h2>
            <ul className="cards">
                {cards?.map((card: any, k: number) => (
                    <li className={`card ${active === k ? 'active' : ''}`} key={k}>
                        <div className="card-img">
                            <EFPicture
                                src={card?.img.includes('http') ? card?.img : `${card?.img}.jpg`}
                                srcPad={card?.img.includes('http') ? card?.img : `${card?.img}_768.jpg`}
                                srcMobile={card?.img.includes('http') ? card?.img : `${card?.img}_768.jpg`}
                                alt={card?.tab}
                            />
                        </div>
                        <div className="card-info">
                            <div className="card-features">
                                <div className="card-feature long">
                                    <p className="card-title">{t('secR_feature_number')}</p>
                                    <p className="card-desc">{card?.number}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secR_feature_capacity')}</p>
                                    <p className="card-desc">{card?.capacity}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secR_feature_voltage')}</p>
                                    <p className="card-desc">{card?.voltage}</p>
                                </div>
                                <div className="card-feature">
                                    <p className="card-title">{t('secR_feature_input')}</p>
                                    <p className="card-desc">{card?.input}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {cards?.map((card: any, k: number) => (
                    <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => handleClickTab(k)}>
                        {card?.tab}
                    </li>
                ))}
            </ul>
            {locale === 'au' && <EfSpec />}
        </section>
    );
}
